import {useLocalization} from "../i18n";
import React from "react";
import {Avatar, PushButton, Table, TableBody, TableCell, TableHead, TableRow} from "@variocube/cube-ui";
import {ItemTableCell} from "./admin/ItemTableCell";
import {Item, Rental, RentalState} from "./types";
import {Occupancy} from "@variocube/app-api";
import {DateTime} from "luxon";
import {stylesheet} from "typestyle";

export interface RentalTableProps {
    rentals: Rental[];
    items: Item[];
    occupancies: Occupancy[];
    onRentalSelect: (rental: Rental) => void;
}

export function RentalTable({rentals, items, occupancies, onRentalSelect}: RentalTableProps) {
    const {t, language} = useLocalization();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{t('Item')}</TableCell>
                    <TableCell>{t('Box')}</TableCell>
                    <TableCell>{t('Timeframe')}</TableCell>
                    <TableCell>&nbsp;</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rentals.map(r => {
                    const item = items.find(i => i.uuid === r.itemUuid);
                    const occupancy = item && occupancies.find(occupancy => occupancy.content.item == item.uuid);

                    const canPickup = r.state === RentalState.Created && !!occupancy?.boxNumber;
                    const canReturn = r.state !== RentalState.Created && r.state !== RentalState.BorrowerReturned && r.state !== RentalState.LenderPickedUp;
                    return (
                        <TableRow key={r.uuid}>
                            <ItemTableCell item={item}/>
                            <TableCell>
                                {occupancy?.boxNumber && <Avatar size={1.5}>{occupancy.boxNumber}</Avatar>}
                            </TableCell>
                            <TableCell>
                                <div className={styles.timeframe}>
                                    {DateTime.fromISO(r.from).setLocale(language).toLocaleString(DateTime.DATETIME_SHORT)}
                                    <span>{t("TimeframeTo")}</span>
                                    {DateTime.fromISO(r.until).setLocale(language).toLocaleString(DateTime.DATETIME_SHORT)}
                                </div>
                            </TableCell>
                            <TableCell>
                                {(canPickup || canReturn) && (
                                    <PushButton onClick={() => onRentalSelect(r)}>
                                        {t(canPickup ? 'Pickup' : 'Return')}
                                    </PushButton>
                                )}
                                {r.state === RentalState.BorrowerReturned && (
                                    <span>{t('Returned')}</span>
                                )}
                                {r.state === RentalState.LenderPickedUp && (
                                    <span>{t('LenderPickedUp')}</span>
                                )}
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    )
}


const styles = stylesheet({
    timeframe: {
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
    }
});